/* import __COLOCATED_TEMPLATE__ from './shopping-cart.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();